import { clearTokens } from '../store/services/actions/setAccessTokens'
import { clearPersistedAuthorization } from './authorization'

// Everything a cashier's session leaves on the device belongs to one brand.
export const clearBrandSession = (): void => {
  clearTokens()
  try {
    clearPersistedAuthorization()
  } catch (error) {
    console.warn('Pending bet authorization could not be cleared:', error)
  }
}
